import { dao } from '@platform/dao';
import type { IRecord } from '@platform/core/types';
import { baseApi, listTag, run } from '@platform/state/api/baseApi';
import type { ILawRecordsArg } from './ILawRecordsArg';

/** Стеля записів одного типу в моделі закону (як vizRecords: до 100, за номером). */
const PAGE = 100;

/**
 * Записи моделі закону одним запитом (прототип v4 lawViz: R(k) — записи типу з draft = законопроєкт): усі дочірні типи паралельно,
 * за номером; тип, який не вдалося прочитати, дає порожній перелік. Кешується зі списковими тегами цих типів.
 */
export const lawApi = baseApi.injectEndpoints({
  endpoints: (b) => ({
    lawRecords: b.query<Record<string, IRecord[]>, ILawRecordsArg>({
      queryFn: ({ ws, draftId, sources }) => run(async () => {
        const settled = await Promise.allSettled(sources.map((s) => dao.records.list(ws, s.rt, { filter: `${s.ref}:eq:${draftId}`, pageSize: PAGE, sort: 'code', facets: false })));
        return Object.fromEntries(settled.map((r, i) => [sources[i]!.rt, r.status === 'fulfilled' ? r.value.items : []]));
      }),
      providesTags: (_r, _e, { sources }) => sources.map((s) => listTag(s.rt)),
    }),
  }),
});

export const { useLawRecordsQuery } = lawApi;
